module.exports = __webpack_public_path__ + "img/ctrl-pauli-stub-mid-1.0608f587.svg";